const MANAGER_URL = "https://api2.idha.com.br:3000/api"
const ORDERS_URL = "https://api2.idha.com.br:3001/api"
const PACKING_URL = "https://api2.idha.com.br:3002/api"
const ACCOUNTS_URL = "https://api2.idha.com.br:3103/api"
const AREA_SCHEDULING_URL="https://NAO_CONFIGURADO:3006"
const RESOURCES_URL = "https://api2.idha.com.br:3012/api"

export {
    MANAGER_URL,ORDERS_URL,PACKING_URL,ACCOUNTS_URL,AREA_SCHEDULING_URL,RESOURCES_URL
}